exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".lista-efeitos-colaterais li[data-v-7eb95e6c]:before{content:\"=> \";font-weight:700}", "", {"version":3,"sources":["/home/raphael/work/apl/intranet/src/app/website/grvs/components/BloquearGrvLeilaoAlerta.vue"],"names":[],"mappings":"AACA,qDACE,cAAe,AACf,eAAkB,CACnB","file":"BloquearGrvLeilaoAlerta.vue","sourcesContent":["\n.lista-efeitos-colaterais li[data-v-7eb95e6c]::before {\n  content: '=> ';\n  font-weight: bold;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7eb95e6c","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/app/website/grvs/components/BloquearGrvLeilaoAlerta.vue
// module id = 1952
// module chunks = 2